import {
    List,
    Datagrid,
    TextField,
    NumberField,
    ReferenceField,
    TopToolbar,
    CreateButton,
    ExportButton,
    useRecordContext,
    useDataProvider,
    DataProviderContext,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { useParams } from 'react-router';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { LoadingSection } from '../../common/LoadingSection';
import { NoDataSection } from '../../common/NoDataSection';
import { Ecom_Product_Templates } from '../../custom';
import Button from '@mui/material/Button';
import { Edit } from '@mui/icons-material';
import { DeleteWithDialogAction } from '../../common/DeleteWithDialogAction';
import { useMemo } from 'react';
import useIsPermission from '../../hooks/useIsPermission';
import { createCustomGoDataProvider } from '../../services';
import ProductsLinkField from './ProductLinkField';
import StatusTags from '../../common/StatusTags';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const ListActions = ({ categoryId }: { categoryId: string }) => {
    const navigate = useNavigate();
    return (
        <TopToolbar>
            <CreateButton
                onClick={e => {
                    e.preventDefault();
                    navigate(`/ecom_categories/${categoryId}/ecom_product_templates/create`);
                }}
            />
            <ExportButton />
        </TopToolbar>
    );
};

const EditButton = () => {
    const navigate = useNavigate();
    const record = useRecordContext() as any;
    return (
        <Button
            startIcon={<Edit />}
            onClick={e => {
                navigate(
                    `/ecom_categories/${record?.categoryId}/ecom_product_templates/${record.id}/edit`,
                );
            }}
        >
            Edit
        </Button>
    );
};

const ProductTemplateList = () => {
    const { isUpdatable, isDeletable } = useIsPermission('ECOM_CATEGORIES');
    const navigate = useNavigate();
    let { categoryId } = useParams();
    if (!categoryId) {
        return <LoadingSection />;
    }
    const baseDataProvider = useDataProvider();
    const customDataProvider = useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_product_templates', apiEndpoint: '/ecom/product-templates' },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <List
                empty={
                    <NoDataSection
                        resource={'ecom_product_templates'}
                        onCreate={() => {
                            navigate(
                                `/ecom_categories/${categoryId}/ecom_product_templates/create`,
                            );
                        }}
                    />
                }
                actions={<ListActions categoryId={categoryId} />}
                filter={{ categoryId: categoryId }}
                resource={'ecom_product_templates'}
            >
                <Datagrid bulkActionButtons={false}>
                    <TextField source="name" />
                    <StatusTags source="status" />
                    <ProductsLinkField />
                    <FormattedDateTimeField source="created_at" />
                    {isUpdatable && <EditButton />}
                    {isDeletable && (
                        <ConfirmDeleteButton
                            path={`ecom_categories/${categoryId}/ecom_product_templates`}
                        />
                    )}
                </Datagrid>
            </List>
        </DataProviderContext.Provider>
    );
};
export default ProductTemplateList;
